<template>
  <b-card>
    <b-table
      :items="reChangeFormat"
      :fields="fields"
      small
      :busy="loader"
      responsive
      bordered
      striped
      show-empty
    >
      <template #head()="data">
        <span>{{ $t(`${data.label}`) }}</span>
      </template>
      <template #table-busy>
        <div class="text-success my-2 d-flex justify-content-center align-items-center">
          <b-spinner />
          <strong class="px-1">Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          <strong>
            {{ $t("objects.no_data") }}
          </strong>
        </div>
      </template>
      <template #thead-top>
        <b-tr class="text-center">
          <b-th colspan="2">
            <span class="sr-only">Name and ID</span>
          </b-th>
          <b-th
            variant="secondary"
            colspan="2"
          >
            {{ $t("reports.apartments_by_projects") }}
          </b-th>
          <b-th
            variant="primary"
            colspan="3"
          >
            {{ $t("general.sold_flats") }}
            <br>
            <small> ({{ $t('general.according_to_the_contract_down') }}) </small>
          </b-th>
          <b-th
            variant="danger"
            colspan="3"
          >
            {{ $t('general.unsolder_flat') }} <br>
          </b-th>
          <b-th
            variant="danger"
            colspan="2"
          >
            {{ $t('reports.paid_amount') }}
          </b-th>
          <b-th
            variant="danger"
            colspan="2"
          >
            {{ $t("general.debt_by_contract") }}
          </b-th>
          <b-th
            variant="danger"
            colspan="2"
          >
            {{ $t("general.expired_debt") }}
          </b-th>
        </b-tr>
      </template>
      <template #cell(total_sold_flat_amount)="props">
        {{ $_moneyFormatter(props.item.total_sold_flat_amount) }}
      </template>
      <template #cell(total_not_sold_flat_amount)="props">
        {{ $_moneyFormatter(props.item.total_not_sold_flat_amount) }}
      </template>
      <template #cell(total_paid_transaction_amount)="props">
        {{ $_moneyFormatter(props.item.total_paid_transaction_amount) }}
      </template>
      <template #cell(total_debt)="props">
        {{ $_moneyFormatter(props.item.total_debt) }}
      </template>
      <template #cell(total_month_debt)="props">
        {{ $_moneyFormatter(props.item.total_month_debt) }}
      </template>
      <template #cell(total_debt)="props">
        {{ $_moneyFormatter(props.item.total_debt) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  BCard, BSpinner, BTr, BTh, BTable,
} from 'bootstrap-vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: true,

      fields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'title',
          label: 'navbars.object_name',
        },
        {
          key: 'total_flat_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_flat_area',
          label: 'm2',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_sold_flat_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_sold_flat_area',
          label: 'm2',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_sold_flat_amount',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_not_sold_flat_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_not_sold_flat_area',
          label: 'm2',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_not_sold_flat_amount',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_paid_transaction_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_paid_transaction_amount',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_month_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },

  computed: {
    ...mapGetters('objects', ['GET_REPORTS_TABLE']),
    totalFlatCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_flat_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalDebt() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalDebtCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_debt_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalFlatArea() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_flat_area)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalMonthDebt() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalMonthDebtCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_month_debt_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalNotSoldFlatAmount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_not_sold_flat_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalNotSoldFlatArea() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_not_sold_flat_area)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalNotSoldFlatCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_not_sold_flat_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalPaidTransactionAmount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_paid_transaction_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalPaidTransactionCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_paid_transaction_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalSoldFlatAmount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_sold_flat_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalSoldFlatArea() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_sold_flat_area)
      return this.decimalAdjust('round', data.reduce((oldValue, newValue) => oldValue + newValue, 0), -2)
    },
    totalSoldFlatCount() {
      const data = this.GET_REPORTS_TABLE.map(item => item.total_sold_flat_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    reChangeFormat() {
      const dataObject = [
        {
          title: this.$t('general.last'),
          total_debt: this.totalDebt,
          total_debt_count: this.totalDebtCount,
          total_flat_area: this.totalFlatArea,
          total_flat_count: this.totalFlatCount,
          total_month_debt: this.totalMonthDebt,
          total_month_debt_count: this.totalMonthDebtCount,
          total_not_sold_flat_amount: this.totalNotSoldFlatAmount,
          total_not_sold_flat_area: this.totalNotSoldFlatArea,
          total_not_sold_flat_count: this.totalNotSoldFlatCount,
          total_paid_transaction_amount: this.totalPaidTransactionAmount,
          total_paid_transaction_count: this.totalPaidTransactionCount,
          total_sold_flat_amount: this.totalSoldFlatAmount,
          total_sold_flat_area: this.totalSoldFlatArea,
          total_sold_flat_count: this.totalSoldFlatCount,
        },
      ]
      return [...this.GET_REPORTS_TABLE, ...dataObject]
    },
  },

  mounted() {
    this.FETCH_REPORTS_TABLE().then(() => {
      this.loader = false
    })
  },

  methods: {
    ...mapActions('objects', ['FETCH_REPORTS_TABLE']),
    decimalAdjust(type, value, exp) {
      // type = String(type)
      // if (!['round', 'floor', 'ceil'].includes(type)) {
      //   throw new TypeError(
      //     "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'.",
      //   )
      // }
      // exp = Number(exp)
      // value = Number(value)
      if (exp % 1 !== 0 || Number.isNaN(value)) {
        return NaN
      } if (exp === 0) {
        return Math[type](value)
      }
      const [magnitude, exponent = 0] = value.toString().split('e')
      const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`)
      // Shift back
      const [newMagnitude, newExponent = 0] = adjustedValue.toString().split('e')
      return Number(`${newMagnitude}e${+newExponent + exp}`)
    },
  },
}
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}

.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}
</style>
